// extracted by mini-css-extract-plugin
export default {"icon":"_2aab1573","svgIcon":"_b8893c71"};